import { IRouterOption } from 'src/router'
import { Applicants } from './components/applicants'
import { ViewCampaignDetail } from './components/detail/view-detail'
import { Campaigns } from './components/list'
import { PublicGuestOnboardingSubmissions } from './components/list/public-guest-onboarding-submissions'
import { PublicSubmissions } from './components/list/public-submissions'
import { MyJobs } from './components/my-jobs'
import { CreateCampaign } from './components/my-jobs/components/create-campaign'
import { PublicGuestOnboarding } from './components/my-jobs/public-guest-onboarding'
import { PublicMyJobs } from './components/my-jobs/public-my-jobs'
import { PreviewCampaign } from './components/preview'
import { SubmissionDetail } from './components/submission-detail'
import { ECampaignRoutes } from './routes.enum'

export const CampaignRoutes: IRouterOption[] = [
  {
    path: ECampaignRoutes.CAMPAIGN_MY_JOBS,
    component: MyJobs,
    name: ECampaignRoutes.CAMPAIGN_MY_JOBS,
    exact: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: ECampaignRoutes.CREATE_CAMPAIGN,
    component: CreateCampaign,
    name: ECampaignRoutes.CREATE_CAMPAIGN,
    exact: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: ECampaignRoutes.CAMPAIGNS_APPLICANTS,
    component: Applicants,
    name: ECampaignRoutes.CAMPAIGNS_APPLICANTS,
    exact: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: ECampaignRoutes.CAMPAIGN_SUBMISSIONS,
    component: Campaigns,
    name: ECampaignRoutes.CAMPAIGN_SUBMISSIONS,
    exact: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: ECampaignRoutes.PREVIEW_CAMPAIGN,
    component: PreviewCampaign,
    name: ECampaignRoutes.PREVIEW_CAMPAIGN,
    exact: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: ECampaignRoutes.CAMPAIGN_SUBMISSION_DETAIL,
    component: SubmissionDetail,
    name: ECampaignRoutes.CAMPAIGN_SUBMISSION_DETAIL,
    exact: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: ECampaignRoutes.CAMPAIGN_DETAIL,
    component: ViewCampaignDetail,
    name: ECampaignRoutes.CAMPAIGN_DETAIL,
    exact: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: ECampaignRoutes.CAMPAIGNS_PUBLIC_ONBOARDING_SUBMISSIONS,
    component: PublicGuestOnboardingSubmissions,
    name: ECampaignRoutes.CAMPAIGNS_PUBLIC_ONBOARDING_SUBMISSIONS,
    exact: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: ECampaignRoutes.CAMPAIGNS_PUBLIC_ONBOARDING,
    component: PublicGuestOnboarding,
    name: ECampaignRoutes.CAMPAIGNS_PUBLIC_ONBOARDING,
    exact: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: ECampaignRoutes.CAMPAIGNS_PUBLIC_SUBMISSIONS,
    component: PublicSubmissions,
    name: ECampaignRoutes.CAMPAIGNS_PUBLIC_SUBMISSIONS,
    exact: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: ECampaignRoutes.CAMPAIGNS_PUBLIC,
    component: PublicMyJobs,
    name: ECampaignRoutes.CAMPAIGNS_PUBLIC,
    exact: true,
    meta: {
      requireAuth: false
    }
  }
]
